import { render, staticRenderFns } from "./CompraDetalhesProdutos.vue?vue&type=template&id=687b1756"
import script from "./CompraDetalhesProdutos.vue?vue&type=script&lang=js"
export * from "./CompraDetalhesProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports